import { Directive, TemplateRef, input } from '@angular/core';
import { IHasTableConfig } from '../pagination-table-config';

export declare class PaginationTableColumnExportDisplayDirectiveContext<
	T = unknown,
> {
	$implicit: T;
	rowId: number;
}

@Directive({
	selector: 'ng-template[aePgtExportDisplay]',
})
export class PaginationTableColumnExportDisplayDirective<T> {
	readonly aePgtExportDisplay = input<IHasTableConfig<T, any>>();

	constructor(
		public template: TemplateRef<
			PaginationTableColumnExportDisplayDirectiveContext<T>
		>,
	) {}

	static ngTemplateGuard_aePgtExportDisplay: 'binding';
	static ngTemplateContextGuard<T>(
		_dir: PaginationTableColumnExportDisplayDirective<T>,
		_ctx: any,
	): _ctx is PaginationTableColumnExportDisplayDirectiveContext<T> {
		return true;
	}
}
